import {
  GET_ODD_HISTORY_REQUEST,
  GET_ODD_HISTORY_SUCCESS,
  GET_ODD_HISTORY_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ODD_HISTORY_REQUEST:
      return {
        ...state,
        data: [],
        isLoading: true,
        error: null
      };

    case GET_ODD_HISTORY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };

    case GET_ODD_HISTORY_FAILURE:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
